import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/download'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'資料ダウンロード 資料請求 ホワイトペーパー 調査資料'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/download'}
        title="資料ダウンロード | Aitria（アイトリア）"
        description="アプリケーション開発やUX/UIに関する調査資料、戦略フレームワークなど、さまざまなジャンルのお役立ち資料を提供しています。ぜひダウンロードしてご活用ください。"
      />
      <Template />
    </>
  )
}

export default Download
